import { useEffect, useState } from "react";
import { DateTime } from "luxon";

import { settingsAjax } from "../../ajax/SettingsAjax";
import { DoubleShift } from "../../types/Shift";
import { ErrorResponse } from "../../DTOs/Common/ErrorResponse";
import { ShiftLockState } from "../../utilities/helpers/shiftLockStateHelpers";

function useShiftLockInfo(selectedDate?: DateTime, selectedShift?: DoubleShift) {
  const [shiftLockState, setShiftLockState] = useState<ShiftLockState | null>(null);
  const [isShiftLockInfoLoading, setShiftLockInfoLoading] = useState(false);

  useEffect(() => {
    let mounted = true;

    const fetchShiftLockInfo = async () => {
      try {
        setShiftLockInfoLoading(true);
        const response = await settingsAjax.getShiftLockInfo()

        if (!mounted || response instanceof ErrorResponse) return;
        setShiftLockState(response)
      }
      catch (e) {
        // ignore
      }
      finally {
        mounted && setShiftLockInfoLoading(false);
      }
    }

    fetchShiftLockInfo()
    return () => { mounted = false; };
  }, [selectedDate, selectedShift]);

  return { shiftLockState, isShiftLockInfoLoading };
}

export default useShiftLockInfo